/* Human Tech Medica: förslag på startvecka utifrån operationsdatum.
   Visar bara ett förslag. Själva bokningen görs i hyreskalendern (Hyrekit). */
(function () {
  var MAN = ['jan', 'feb', 'mar', 'apr', 'maj', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'];
  var DAG = 86400000;

  function fmt(d, box) { var m = (box && box.dataset.tManader) ? box.dataset.tManader.split(',') : MAN; return d.getDate() + ' ' + m[d.getMonth()]; }

  function veckonummer(d) {
    var t = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
    var dag = t.getUTCDay() || 7;
    t.setUTCDate(t.getUTCDate() + 4 - dag);
    var arStart = new Date(Date.UTC(t.getUTCFullYear(), 0, 1));
    return Math.ceil(((t - arStart) / DAG + 1) / 7);
  }

  function mandagFore(d) {
    var m = new Date(d.getTime());
    var dag = (m.getDay() + 6) % 7; /* måndag = 0 */
    m.setDate(m.getDate() - dag);
    return m;
  }

  function init(box) {
    if (box.dataset.htmInit) return;
    box.dataset.htmInit = '1';
    var input = box.querySelector('input[type="date"]');
    var svar = box.querySelector('[data-htm-svar]');
    var lead = parseInt(box.dataset.leadDays || '2', 10);
    var idag = new Date(); idag.setHours(12, 0, 0, 0);
    input.min = new Date(idag.getTime()).toISOString().slice(0, 10);

    input.addEventListener('change', function () {
      if (!input.value) { svar.textContent = ''; return; }
      var op = new Date(input.value + 'T12:00:00');
      var senast = new Date(op.getTime() - lead * DAG);
      var start = mandagFore(senast);
      var slut = new Date(start.getTime() + 6 * DAG);
      if (start < mandagFore(idag)) {
        svar.textContent = box.dataset.textNara;
        return;
      }
      var mall = box.dataset.tForslag || 'Vi föreslår start vecka [vecka] ([fran]–[till]) så att utrustningen finns hemma före [handelse] den [datum]. Välj den veckan i kalendern nedan.';
      svar.textContent = mall.replace('[vecka]', veckonummer(start)).replace('[fran]', fmt(start, box)).replace('[till]', fmt(slut, box))
        .replace('[handelse]', box.dataset.handelse || 'din operation').replace('[datum]', fmt(op, box));
    });
  }

  function alla() { document.querySelectorAll('[data-htm-bokning]').forEach(init); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', alla); } else { alla(); }
  document.addEventListener('shopify:section:load', alla);
})();

/* Human Tech Medica: förvälj manschett från länken, till exempel ?manschett=Nose+Cuff.
   Kunden kan sedan byta manschett som vanligt. */
(function () {
  function norm(t) { return String(t || '').toLowerCase().replace(/\s+/g, ' ').replace(/länk/g, 'link').replace(/\butan\b/g, 'uden').trim(); }
  function forval() {
    var onskad = norm(new URLSearchParams(window.location.search).get('manschett'));
    if (!onskad) return;
    var radios = document.querySelectorAll('variant-selects input[type="radio"]');
    for (var i = 0; i < radios.length; i++) {
      if (norm(radios[i].value) === onskad) {
        if (!radios[i].checked) {
          radios[i].checked = true;
          radios[i].dispatchEvent(new Event('change', { bubbles: true }));
        }
        return;
      }
    }
    var listor = document.querySelectorAll('variant-selects select');
    for (var j = 0; j < listor.length; j++) {
      var alt = listor[j].options;
      for (var k = 0; k < alt.length; k++) {
        if (norm(alt[k].value) === onskad) {
          if (listor[j].selectedIndex !== k) {
            listor[j].selectedIndex = k;
            listor[j].dispatchEvent(new Event('change', { bubbles: true }));
          }
          return;
        }
      }
    }
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', forval); } else { forval(); }
})();

/* Human Tech Medica: korta beskrivningar under manschettvalen på produktsidan. */
(function () {
  function norm(t) { return String(t || '').toLowerCase().replace(/\s+/g, ' ').trim(); }
  function karta() {
    var el = document.querySelector('[data-htm-mbeskr]');
    if (!el) return null;
    try {
      var data = JSON.parse(el.textContent);
      var ut = {};
      Object.keys(data).forEach(function (k) { ut[norm(k)] = data[k]; });
      return ut;
    } catch (e) { return null; }
  }
  function lagg() {
    var k = karta();
    if (!k) return;
    document.querySelectorAll('variant-selects input[type="radio"]').forEach(function (inp) {
      var lbl = document.querySelector('label[for="' + inp.id + '"]');
      if (!lbl || lbl.querySelector('.htm-variant-beskr')) return;
      var text = k[norm(inp.value)];
      if (!text) return;
      var span = document.createElement('span');
      span.className = 'htm-variant-beskr';
      span.textContent = text;
      lbl.appendChild(span);
    });
  }
  var vantar = false;
  function snart() { if (!vantar) { vantar = true; window.requestAnimationFrame(function () { vantar = false; lagg(); }); } }
  function start() {
    lagg();
    var rot = document.querySelector('product-info') || document.body;
    new MutationObserver(snart).observe(rot, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', start); } else { start(); }
  document.addEventListener('shopify:section:load', snart);
})();
